import './InfoTip.css'

/**
 * The "i" badge beside a section heading, with its hover/focus tooltip.
 *
 * Keyboard-reachable on purpose: the tooltip is the only place several of the
 * product's rules are explained (what a match means, who advances a stage,
 * what the aggregates are drawn from), so it cannot be mouse-only.
 *
 * The copy lives in TIPS below, lifted verbatim from the locked reference —
 * these are product statements about confidentiality and data provenance, not
 * decoration, so they should not be paraphrased in passing.
 */
export const TIPS = {
  difference:
    'How NexExec differs from a résumé database: profiles are built for company-side evaluation, with candidate-controlled visibility',
  recommended:
    'Confidential executive profiles matched to your open roles. Identity is released to you only after an executive accepts Interview #1.',
  savedSearches: 'Searches you saved, with matches added since you last viewed them',
  pipelines:
    'Stage counts come from the shared engagement record with each executive. Neither side advances a stage on its own.',
  recentlyViewed: 'Executives you or your team recently opened, shortlisted, or shared',
  engagements: 'Engagements where a Conversation or Interview stage is currently open',
  decisionDocs:
    'Structured documentation that supports your evaluation. It does not recommend a hiring decision.',
  marketPulse:
    'Privacy-safe aggregates from platform activity. No individual executive or company is identifiable.',
  marketSource: 'Aggregated across NexExec, not from your company’s activity alone',
  teamActivity:
    'What your hiring team has done recently across pipelines, candidates, and Decision Documentation',
} as const

export function InfoTip({ tip }: { tip: keyof typeof TIPS }) {
  return (
    <span className="i" tabIndex={0} role="button" aria-label="More information" data-tip={TIPS[tip]}>
      i
    </span>
  )
}
